import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'

import myrouter from '@/router/index.js'
Vue.use(VueRouter)

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import './assets/layout.css'
Vue.use(VueMaterial)

import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);

import IO from 'socket.io-client'
import VueSocketIO from 'vue-socket.io'

const optionsVueIO = {
  connection: IO()
}

Vue.use(new VueSocketIO(optionsVueIO))

import createStore from '@/store/index.js'
//import createWebSocketPlugin from './store/createWebSocketPlugin'
//const websocketPlugin = createWebSocketPlugin(optionsVueIO.connection)
//const myStore = new Vuex.Store({ module: {main: store}, plugin: [websocketPlugin]})
Vue.config.productionTip = false
Vue.prototype.$isMobile = function () {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true
  } else {
    return window.innerWidth < 800
  }
};

new Vue({
  router: myrouter,
  store: createStore(optionsVueIO.connection),
  render: h => h(App),
}).$mount('#app')
